<template>
  <div>
    <base-modal :showing="visible" @close="$emit('close')" @opened="onOpened">
      <base-card
        :with-style="false"
        title="Daftar Alamat"
        description="Daftar alamat pengiriman"
      >
        <div class="border-t pt-5">
          <datatable
            :columns="[
              { id: 'address', name: 'Address' },
              { id: 'action', name: 'Aksi', theadClass: 'text-right' },
            ]"
          >
            <template #tbody="{ classes }">
              <tr
                v-for="address in addresses.data"
                :key="address.id"
                :class="[classes.tr, 'hover:bg-green-100']"
              >
                <td
                  :class="[classes.td, 'cursor-pointer']"
                  @click="onDetail(address)"
                >
                  <p class="font-bold text-gray-900">
                    {{ address.attributes.name }},
                    {{ address.attributes.phone }}
                  </p>
                  <p>
                    {{ address.attributes.detail }},
                    {{ address.attributes.village_name }},
                    {{ address.attributes.district_name }},
                    {{ address.attributes.city_name }},
                    {{ address.attributes.province_name }}
                  </p>
                </td>
                <td :class="[classes.td, 'text-right']">
                  <button @click="onDelete(address)">
                    <Icon
                      icon="heroicons:trash-solid"
                      class="h-4 w-4 text-red-600"
                    />
                  </button>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </base-card>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal';
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
  },
  props: {
    visible: Boolean,
    officeId: String,
  },
  emits: ['close', 'select'],
  data() {
    return {
      addresses: {
        data: [],
      },
      loadingDelete: false,
      loadingRead: false,
    };
  },
  computed: {
    loading() {
      return this.loadingDelete || this.loadingRead;
    },
  },
  methods: {
    async loadAddresses() {
      this.loadingRead = true;

      const [res, err] = await this.request(
        `/api/v1/offices/${this.officeId}/addresses`
      );

      if (!err) {
        this.addresses = res;
      }

      this.loadingRead = false;
    },
    onOpened() {
      this.loadAddresses();
    },
    onDetail(address) {
      this.$emit('select', address);
    },
    async onDelete(address) {
      this.loadingDelete = true;

      const [, err] = await this.request(`/api/v1/addresses/${address.id}`, {
        method: 'delete',
      });

      if (!err) {
        this.loadAddresses();
      }

      this.loadingDelete = false;
    },
  },
};
</script>
